import {Component} from 'react';
import { Button } from 'react-bootstrap';
import "./ForParents/forParents.css";
import "../../css/styles.css";
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import GameFeedbackDisplayModal from '../admin/game_feedback_display_modal';
import PlayerFeedbackDisplayModal from '../admin/player_feedback_display_modal';
import GameProfileDisplayModal from '../admin/game_profile_display_modal';
import JobListModal from '../admin/job_list_modal';
import SavingsOverTimeModal from '../extra_credit/savings_over_time_modal';
import LoanCalculatorModal from '../extra_credit/loan_calculator_modal';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import LeaderBoardModal from '../game-views/leader_board_modal';
import DiscussionGameData from './datasets/discussion_game_data';
import DiscussionSavingsData from './datasets/discussion_savings_data';
import DiscussionCreditCardData from './datasets/discussion_credit_card_data';
import Config from '../../config';
import {buildUrl} from '../../objects/CommonUse/build_URL';
import combinePlayerChoices from '../../objects/CommonUse/combine_player_choices';
import MoneyMgmtStudentTestModal from '../admin/money_mgmt_student_test_modal';
import MoneyMgmtTestByTopicModal from '../admin/money_mgmt_test_by_topic_modal';
import CreditCardCalculatorModal from '../extra_credit/credit_card_calculator_modal';
import MonthlyStatusModal from '../game-views/monthly_status_modal';
import DiscussionTextModal from './discussion_text_modal';
import CreditReportModal from '../game-views/credit_report_modal';
import AwardsExtraCreditModal from '../admin/awards_extra_credit_modal';
import determineCreditScore from '../game-views/objectsEndOfTurn/determine_credit_score';
import SelectClassModal from './select_class_modal';
import AwardPlayerDetailModal from '../admin/award_player_detail_modal';

class PlayerReports extends Component {
    constructor(props) {
        super(props);
        this.parentInfo = this.props.parentInfo();
        this.state={
          headers: setHeadersForFetch(),  
          loadGameData: false,
          loadSavingsData: false,
          loadCreditCardData: false,
          loadTimeWizardData: false,
          loadJobChoiceData: false,
          loadHomeChoiceData: false,
          loadCarChoiceData: false,
          extraCreditLoaded: false,
          waitState: false,
          calculateOnly: true,
          modalOpen: false,
          subProcess: "playerReports",
          environment: Config.dataURL.currentEnv,
          openStatusModal: false,
          openCreditReport: false,
          openSelectClass: false,
          openAwardDetail: false
        };   
        this.gameFeedback = null;
        this.playerFeedback = null;
        this.gameData = [];
        this.savingsData = [];
        this.creditCardData = [];
        this.timeWizardData = [];
        this.gameChoicesData = [];
        this.jobList = null;
        this.moneyMgmtTestData = null;
        this.openProcessName = "";
        this.gameDataLoaded = true;
        this.badgeExtraCreditLoaded = false;
        this.pdfDocAddress = "https://assets.playmoneytrain.com/player_reports_discussion_guide.pdf";
        this.setPrimaryRole();
    }

    setPrimaryRole(){
        let rqstdUsersArr = this.parentInfo.accountInfo.rqstdUsersArr;
        this.primaryRole = "";
        for (let i=0; i<rqstdUsersArr.length; i++){
            if (rqstdUsersArr[i].role ===  "player"){
                //  skip player part of this array
            }else{
                this.primaryRole = rqstdUsersArr[i].role;
            }
        }
    }

    openSelectClassModal(){
        this.setState({openSelectClass: true});
    }
    
    changeClassCode(newClassCode){
        this.props.changeClassCode(newClassCode);
        this.closeModal("selectClass");
    }

    closeSelectClassModal(){
        this.setState({openSelectClass: false});
    }

    reportSelected(reportType){
        if (reportType === "savings" || reportType === "loans" || reportType === "creditCard"
            || reportType === "leaderBoard"){
            //   these do not require fetch for data
        }else{
            this.setState({waitState: true, modalOpen: false});
        }
        if (reportType === "gameProfile" || reportType === "discussion"){
            this.gameDataLoaded = false;
        }else{
            this.gameDataLoaded = true;
        }
        switch (reportType){
            case "gameProfile":
                this.setState({modalOpen: true});
                this.openProcessName = "GameProfile";
                this.loadGamesForAccount();
                break;
            case "leaderBoard":
                this.accountNbr = sessionStorage.getItem("rptAccountNbr");
                this.openProcessName = "leaderBoard";
                this.setState({modalOpen: true});
                break;
            case "savings":
                this.openProcessName = "savingsCalculator";
                this.setState({modalOpen: true});
                break;
            case "loans":
                this.openProcessName = "loanCalculator";
                this.setState({modalOpen: true});
                break;
            case "Game":
                this.loadGameFeedback();
                break;
            case "Player":
                this.loadPlayerFeedback();
                break;
            case "jobList":
                this.loadJobList();
                break;
            case "discussion":
                this.openProcessName = "GameProfile";
                this.loadDiscussionData();
                break;
            case "creditCard":
                this.openProcessName = "creditCardCalculator";
                this.setState({modalOpen: true});
                break;
            case "studentTest":
                this.loadStudentTests(reportType);
                break;
            case "testAssess":
                this.loadStudentTests();
                break;
            case "badgesExtraCredit":
                this.setState({modalOpen: true});
                this.openProcessName = "BadgeExtraCredit";
                this.loadGamesForAccount();
                break;
            default:
                break;
            
        }
    }

    displayStatus(playerName)
    {
        for (let i=0; i<this.gameData.length; i++){
            let gameData = this.gameData[i];
            if (gameData.user === playerName){
                this.props.setParentInfo(gameData, "gameData");
                break;
            }
        }
        this.openProcessName = "PlayerStatus";
        this.setState({openStatusModal: true});
  }

  closeStatusModal(){
        this.openProcessName = "GameProfile"
        this.setState({openStatusModal: false});
  }

    closeDiscussionPrompt(){
        this.setState({openDiscussionModal: false});
    }
    
    closeReportModals(){
        this.openProcessName = "";
        this.setState({modalOpen: false, loadGameData: false});
    }

    closeModal(reportName){
        switch (reportName){
            case "awardPlayerDetail":
                this.gameRqstType = "awardExtraCredit"; 
                this.setState({openAwardDetail: false, modalOpen: true});
                break;
            case "badgeExtraCredit":
                this.openProcessName = "BadgeExtraCredit";
                this.badgeExtraCreditLoaded = true
                this.setState({modalOpen: false});
                break;
            case "leaderBoard":
                this.openProcessName = "";
                this.setState({modalOpen: false});
                break;
            default:
                break;      
        }
    }
        
    openCreditReportModal(){
        this.openProcessName = "creditReport";
        this.creditReport = determineCreditScore(this.creditCardData, 
                this.parentInfo.gameData.loanTable, this.parentInfo.gameData.currentGameDate,
                this.parentInfo.gameData.gameNbrMonths, this.timeWizardData );
        this.setState({openCreditReport: true, openStatusModal: false});
    }

    closeCreditReportModal(){
        this.openProcessName = "playerStatus";
        this.setState({openStatusModal: true, openCreditReport: false});
    }

    
    displayPlayerAwardDetail(player){
        this.closeModal("awardExtraCredit");
        this.playerName = player;
        const extraIndx = this.extraCreditArr.findIndex(elem => elem.user === player);
        if (extraIndx === -1){
            this.playerExtraCredit = {};
        }else{
            this.playerExtraCredit = this.extraCreditArr[extraIndx].extraCreditTable;
        }
        const achieveIndx = this.achievements.findIndex(elem => elem.user === player);
        if (achieveIndx === -1){
            this.playerAchievements = {};
        }else{
            this.playerAchievements = this.achievements[achieveIndx].achievementArr;
        }
        const badgeIndx = this.badgeArr.findIndex(elem => elem.user === player);
        if (badgeIndx === -1){
            this.playerBadges = {};
        }else{
            this.playerBadges = this.badgeArr[badgeIndx].badgesEarned;
        }
        this.setState({openAwardDetail: true});
    }
  
    render() {
        if (this.state.loadJobChoiceData ===  true && this.state.loadCarChoiceData ===  true &&
            this.state.loadHomeChoiceData ===  true && this.gameDataLoaded ===  false){
                this.allChoicesArr = combinePlayerChoices(this.gameChoiceArr, this.jobChoiceData,
                    this.homeChoiceData, this.carChoiceData);
                     this.gameDataLoaded = true;
        }
        if (this.openProcessName === "BadgeExtraCredit" && this.state.loadGameData === true &&
            this.state.extraCreditLoaded === true){
                this.waitState = false;
                this.badgeExtraCreditLoaded = true;
        }
       
  
    return <>
           <div className="col-8">
                <div className="card mt-3 mr-5 rounded-corners-lg h-100">
                    <button className="pages-back-button ml-4 mt-4" 
                        onClick ={()=> this.props.goBack()}>
                                Back
                    </button>
                   
                    <h3 className="my-0 text-center">Player Reports</h3>
                    <div>
                    <h3 className="text-center text-primary">{this.parentInfo.accountInfo.className}</h3>
                     {this.primaryRole === "teacher"  && this.parentInfo.accountList.length > 1  ?
                        <div className="ml-4">
                                <Button variant="primary" className="py-0"
                                    onClick={() => this.openSelectClassModal()}>
                                        Select A Different Class 
                                </Button>
                        </div>
                    :
                        null
                    }
                    </div>
                    <div className="mx-4 mt-2">
                          The reports available on this page can be displayed to view the
                          status and key information about the game ...OR... in conjunction
                          with the discussion guide (link provided below).
                    </div>
                    
                    <table className="mt-2 overflow-scroll">
                    <tbody className="row-100" >
                        <tr >
                            <td className="col-sm-4 text-center">
                                <button className="btn-group-wide mt-3 px-0" 
                                    onClick ={()=> this.reportSelected("gameProfile")}>
                                            Game Profiles
                                </button>
                            </td>
                            <td className="col-sm-4 text-center">
                                <button className="btn-group-wide mt-3 px-0" 
                                    onClick ={()=> this.reportSelected("leaderBoard")}>
                                           Leader Board for Class
                                </button>
                            </td>
                            <td className="col-sm-4 text-center">
                                <button className="btn-group-wide mt-3 px-0" 
                                    onClick ={()=> this.reportSelected("jobList")}>
                                           Job List
                                </button>
                            </td>
                           
                        </tr>
                        <tr>
                            <td className="col-sm-4 text-center">
                                <button className="btn-group-wide mt-3 px-0" 
                                    onClick ={()=> this.reportSelected("loans")}>
                                           Loan Calculator
                                </button>
                            </td>
                            <td className="col-sm-4 text-center">
                                <button className="btn-group-wide mt-3 px-0" 
                                    onClick ={()=> this.reportSelected("creditCard")}>
                                           Credit Card Calculator
                                </button>
                            </td>
                            <td className="col-sm-4 text-center">
                                <button className="btn-group-wide mt-3 px-0" 
                                    onClick ={()=> this.reportSelected("savings")}>
                                           Savings Calculator
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td className="col-sm-4 text-center">
                                <button className="btn-group-wide mt-3 px-0" 
                                    onClick ={()=> this.reportSelected("Player")}>
                                            Player Comments
                                </button>
                            </td>
                            <td className="col-sm-4 text-center">
                                <button className="btn-group-wide mt-3 px-0" 
                                    onClick ={()=> this.reportSelected("Game")}>
                                            Player Game Feedback
                                </button>
                            </td>
                            <td className="col-sm-4 text-center">
                                <button className="btn-group-wide mt-3 px-0" 
                                    onClick ={()=> this.reportSelected("discussion")}>
                                           Game Profiles for Discussion
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td className="col-sm-4 text-center">
                                <button className="btn-group-wide mt-3 px-0" 
                                    onClick ={()=> this.reportSelected("studentTest")}>
                                            Student Test Results
                                </button>
                            </td>
                            <td className="col-sm-4 text-center">
                                <button className="btn-group-wide mt-3 px-0" 
                                    onClick ={()=> this.reportSelected("testAssess")}>
                                            Test Assessment
                                </button>
                            </td>
                               <td className="col-sm-4 text-center">
                                <button className="btn-group-wide mt-3 px-0" 
                                    onClick ={()=> this.reportSelected("badgesExtraCredit")}>
                                            Awards and Extra Credit Earned
                                </button>
                            </td>
                        </tr>
                           
                    </tbody>
                    </table>
                    <div className="mt-3 text-center">
                  
                    {this.state.waitState  || this.gameDataLoaded  === false ?
                          <h3 className="mt-5">This may take a few minutes to load.</h3>
                    :
                        null
                    }
                </div>
                  
                {this.state.openSelectClass ?
                    <SelectClassModal
                        show={this.state.openSelectClass}
                        accountNbr={this.parentInfo.accountInfo.accountNbr}
                        accountList={this.parentInfo.accountList}
                        onClose={() => this.closeSelectClassModal()}
                        changeClassCode={(newClassCode) => 
                            this.changeClassCode(newClassCode)}
                    />
                :
                    null
                }
                    {this.state.waitState || this.gameDataLoaded === false ?
                       <WaitTimeSpinner/>
                    :
                        <span>
                         {this.openProcessName ===  "leaderBoard" ?
                            <LeaderBoardModal modalOpen={this.state.modalOpen} 
                                accountNbr={this.accountNbr}
                                playerSelected={false}
                                onClose={() => this.closeModal("leaderBoard")} 
                                gameInfo = {() => this.parentInfo}
                            />
                        :
                            <div></div>
                        }

                        {this.openProcessName ===  "savingsCalculator" ?
                            <SavingsOverTimeModal show={this.state.modalOpen}
                                exerciseButtons={true}
                                onClose={() => this.closeReportModals()}
                                calculatorSw={this.state.calculateOnly} 
                                displayInitialAmt={true}/>
                            :
                            <div></div>
                        }

                        {this.openProcessName ===  "loanCalculator"  ?
                            <LoanCalculatorModal show={this.state.modalOpen} 
                                exerciseButtons={true}
                                onClose={() => this.closeReportModals()} 
                                calculatorSw ={this.state.calculateOnly}/>
                        :
                            <div></div>
                        }

                        {this.openProcessName ===  "creditCardCalculator"  ?
                            <CreditCardCalculatorModal show={this.state.modalOpen} 
                                exerciseButtons={true}
                                onClose={() => this.closeReportModals()} 
                            />
                        :
                            <div></div>
                        }

                        {this.openProcessName === "PlayerFeedback" ?
                            <PlayerFeedbackDisplayModal openModal={this.state.modalOpen} 
                                commentsOnly={true}
                                onClose={() => this.closeReportModals()} 
                                playerFeedback={this.playerFeedback}
                                
                            />
                        :
                            null
                        }

                        {this.gameDataLoaded  &&
                            this.openProcessName === "GameProfile"  ?
                                <GameProfileDisplayModal openModal={this.state.modalOpen} 
                                    onClose={() => this.closeReportModals()} 
                                    parentInfo = {() => this.props.parentInfo()} 
                                    setParentInfo = {(value, propertyName) => 
                                        this.props.setParentInfo(value, propertyName)}
                                    gameData={this.gameData}
                                    savingsData={this.savingsData}
                                    creditCardData={this.creditCardData}
                                    timeWizardData={this.timeWizardData}
                                    gameChoicesData={this.allChoicesArr}
                                    displayStatus = {(player) => this.displayStatus(player)} 
                                />
                        :
                            null
                        }

                        {this.openProcessName === "GameFeedback" ?
                            <GameFeedbackDisplayModal openModal={this.state.modalOpen} 
                                onClose={() => this.closeReportModals()} 
                                gameFeedback={this.gameFeedback}
                             
                            />
                        :
                            null
                        }

                        {this.openProcessName === "JobList" ?
                            <JobListModal
                                openModal={this.state.modalOpen}
                                jobListArr={this.jobList}
                                onClose={() => this.closeReportModals()} 
                            />
                        :
                            null
                        }

                        {this.openProcessName === "StudentTest" ?
                            <MoneyMgmtStudentTestModal
                                accountName={this.parentInfo.accountInfo.className}
                                openModal={this.state.modalOpen}
                                financialLiteracyTestArr={this.moneyMgmtTestData}
                                onClose={() => this.closeReportModals()} 
                            />
                        :
                            null
                        }

                        {this.openProcessName === "MoneyMgmtTest" ?
                            <MoneyMgmtTestByTopicModal
                                openModal={this.state.modalOpen}
                                financialLiteracyTestArr={this.moneyMgmtTestData}
                                onClose={() => this.closeReportModals()} 
                            />
                        :
                            null
                        }

                         {this.openProcessName === "PlayerStatus" ?
                            <MonthlyStatusModal modalOpen={this.state.openStatusModal} 
                                fromProcess={"reports"}
                                openCreditReportModal={() => this.openCreditReportModal()}
                                onClose={() => this.closeStatusModal()}
                                onNavigate={(pathname) => this.props.onNavigate(pathname)}
                                gameInfo = {() => this.props.parentInfo()}
                            />
                        :
                            null
                        }
                        
                        {this.openProcessName === "creditReport" ?
                            <CreditReportModal
                                show={this.state.openCreditReport}
                                nbrMonths={this.nbrMonths}
                                user={this.parentInfo.gameData.user}
                                creditReport={this.creditReport}
                                creditInfo={this.creditCardData}
                                loanTable={this.parentInfo.gameData.loanTable}
                                onClose = {() => this.closeCreditReportModal()}
                            />
                        :
                            null
                        }

                         {this.openProcessName === "PlayerStatusDiscussion" ?
                            <div>
                                <DiscussionTextModal
                                    modalOpen = {this.state.openStatusModal}
                                    onClose={() => this.closeDiscussionPrompt()}
                                    />
                                </div>
                            :
                                null  
                        }

                        
                        {this.openProcessName === "BadgeExtraCredit" && this.badgeExtraCreditLoaded  ?
                            <AwardsExtraCreditModal 
                                openModal={this.state.modalOpen}
                                extraCredit={this.extraCreditArr}
                                badgesArr={this.badgeArr}
                                achievements={this.achievements}
                                onClose={() => this.closeModal("badgeExtraCredit")}
                                playerAwardDetail={(player) => this.displayPlayerAwardDetail(player)}
                            />
                        :
                            null
                        }
                        
                        {this.state.openAwardDetail   ?
                            <AwardPlayerDetailModal 
                                openModal={this.state.openAwardDetail}
                                player={this.playerName}
                                extraCredit={this.playerExtraCredit}
                                achievements={this.playerAchievements}
                                badges={this.playerBadges}
                                onClose={() => this.closeModal("awardPlayerDetail")}
                            />
                        :
                            null
                        }

                        </span>
                    }
                    <div className="mt-2 text-center">
                        <a className="decorative light-blue-color text-pointer" 
                            href={this.pdfDocAddress} target="_blank"
                            rel="noreferrer">
                                View Player Reports Discussion Guide (PDF)
                        </a>
                    </div>
                    {this.primaryRole === "teacher"  && this.parentInfo.accountList.length > 1 ?
                        <div className="mt-2 text-center">
                            Use the "Select a Different Class Button" to select the "demo" teacher 
                            and view a sample of the reports.
                        </div>
                    :
                        null
                    }  
                                      
                </div>        
            </div>
        </>
    }
      
loadPlayerFeedback(){
    this.setState({waitState: true});
    let playerArr = (this.parentInfo.relatedPlayers).join(',');
    const funcName = "loadPlayerFeedback";
    const urlParm = "?userList=" + playerArr;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,
       {method:'GET', headers: this.state.headers})
       .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode ===  200){
                    this.openProcessName = "PlayerFeedback";
                    this.sortPlayerFeedback(output.body);
                    this.setState({modalOpen: true, waitState: false});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
}

sortPlayerFeedback(playerFeedback){
    this.playerFeedback = [];
    for (let i=0; i<playerFeedback.length; i++){
        let sortKey = playerFeedback[i].user + playerFeedback[i].dateAdded + playerFeedback[i].timeAdded;
        let feedbackObj = {...playerFeedback[i], sortKey: sortKey};
        this.playerFeedback.push(feedbackObj);
    }
    (this.playerFeedback).sort((a, b) => (a.sortKey > b.sortKey) ? 1 : -1)
}


loadGamesForAccount(){
    this.setState({loadJobChoiceData: false, loadCarChoiceData: false,
        loadHomeChoiceData: false});
    let playerArr = (this.parentInfo.relatedPlayers).join(',');
    const funcName = "loadGamesForAccount";
    const urlParm = "?userNameArr=" + playerArr;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode ===  200){
                        (output.body).sort((a, b) => (a.user > b.user) ? 1 : -1)
                        this.gameData = output.body;
                        if (this.openProcessName === "GameProfile"){
                            this.setGameIdArr();
                            this.loadSavings();
                            this.loadCreditCardInfo();
                            this.loadTimeWizardInfo();
                            this.loadJobChoices();
                            this.loadHomeChoices();
                            this.loadCarChoices();
                        }else{
                            this.buildAwardArr();
                            this.loadExtraCredit();
                        }
                        this.setState({loadGameData: true, waitState: false});
                    }else{
                        if (statusCode === 250){
                            this.gameDataLoaded = true;
                            alert ("There is no game data for students in the selected class.")
                            this.setState({loadGameData: true, waitState: false});
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.props.processError(errorObj);
                        }
                    }
                });
            };
        });
}

setGameIdArr(){
    this.gameIdArr = [];
    this.gameChoiceArr = [];
     for (let i=0; i<this.gameData.length; i++){
          this.gameIdArr.push(this.gameData[i]._id);
          let gameData = this.gameData[i];
          let gameChoiceObj = {gameID: gameData._id, jobID: gameData.jobInfo.careerID,
            homeID: gameData.homeInfo.homeID, carID: gameData.carInfo.carID};
          this.gameChoiceArr.push(gameChoiceObj);
    }
}

buildAwardArr(){
    this.badgeArr = [];
    this.achievements = [];
    for (let i=0; i<this.gameData.length; i++){
        const game = this.gameData[i];
        const badgeObj = {user: game.user, badgesEarned: game.badgesEarned};
        this.badgeArr.push(badgeObj);
        const achievementObj = {user: game.user, achievementArr: game.achievementArr};
        this.achievements.push(achievementObj);
    }
}

loadSavings() {
    let gameID = (this.gameIdArr).join(',');
    const funcName = "loadSavings";
    const urlParm = "?gameID=" + gameID + "&returnType=Multiple";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode ===  200){
                        this.savingsData = output.body;
                        this.setState({loadSavingsData: true});
                    }else{
                        if (statusCode ===  250){
                            this.savingsData = [];
                            this.setState({loadSavingsData: true});
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.props.processError(errorObj);
                        }
                    }
                });
            };
        });
}

loadCreditCardInfo() {
    let gameID = (this.gameIdArr).join(',');
    const funcName = "loadCreditCardInfo";
    const urlParm = "?gameID=" + gameID + "&returnType=Multiple";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
       {method:'GET', headers: this.state.headers})
       .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode ===  200){
                    this.creditCardData = output.body;
                    this.setState({loadCreditCardData: true});
                }else{
                    if (statusCode ===  250){
                        this.creditCardData = [];
                        this.setState({loadCreditCardData: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                }
            });
        };
    });
}

loadTimeWizardInfo() {
    let gameID = (this.gameIdArr).join(',');
    const funcName = "loadTimeWizard";
    const urlParm = "?gameID=" + gameID + "&returnType=Multiple";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
       {method:'GET', headers: this.state.headers})
       .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode ===  200){
                    this.timeWizardData = output.body;
                    this.setState({loadTimeWizardData: true});
                }else{
                    if (statusCode ===  250){
                        this.timeWizardData = [];
                        this.setState({loadTimeWizardData: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                }
            });
        };
    });
}

loadJobChoices(){
    let jobIdArr=[];
    for (let i=0; i<this.gameChoiceArr.length; i++){
          jobIdArr.push(this.gameChoiceArr[i].jobID);
    }
    const jobIdParm = jobIdArr.join(',');
    const funcName = "jobInfo";
    const urlParm = "?jobId=" + jobIdParm + "&returnType=Multiple";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', 
        headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode ===  200){
                    this.jobChoiceData = output.body;
                    this.setState({loadJobChoiceData: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
  }

  
loadHomeChoices(){
    let homeIdArr=[];
    for (let i=0; i<this.gameChoiceArr.length; i++){
          homeIdArr.push(this.gameChoiceArr[i].homeID);
    }
    const homeIdParm = homeIdArr.join(',');
    const funcName = "homeInfo";
    const urlParm = "?homeId=" + homeIdParm + "&returnType=Multiple";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', 
        headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode ===  200){
                    this.homeChoiceData = output.body;
                    this.setState({loadHomeChoiceData: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
  }
    
loadCarChoices(){
    let carIdArr=[];
    for (let i=0; i<this.gameChoiceArr.length; i++){
          carIdArr.push(this.gameChoiceArr[i].carID);
    }
    const carIdParm = carIdArr.join(',')
    const funcName = "carInfo";
    const urlParm = "?carId=" + carIdParm + "&returnType=Multiple";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', 
        headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode ===  200){
                    this.carChoiceData = output.body;
                    this.setState({loadCarChoiceData: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
}

loadGameFeedback(){
    const playerArr = (this.parentInfo.relatedPlayers).join(',');  
    const funcName = "loadGameFeedback";
    const urlParm = "?userList=" + playerArr;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,   
       {method:'GET', headers: this.state.headers})
       .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode ===  200){
                    this.openProcessName = "GameFeedback";
                    this.gameFeedback = output.body;
                    this.setState({modalOpen: true, waitState: false});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
}

loadJobList(){
    const funcName = "jobListAll";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode ===  200){
                        this.openProcessName = "JobList";
                        this.jobList = output.body;
                        this.jobList = 
                            this.jobList.sort((a, b) => (a.jobName > b.jobName) ? 1 : -1)
                        this.setState({modalOpen: true, waitState: false});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
  }
  
  loadStudentTests(reportType){
    const funcName = "loadFinancialLiteracyTest";
    const playerArr = (this.parentInfo.relatedPlayers).join(',');  
    const urlParm = "?userArr=" + playerArr;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode ===  200){
                        this.moneyMgmtTestData = output.body;
                        this.moneyMgmtTestData = 
                            this.moneyMgmtTestData.sort((a, b) => (a.user + a.dateAdded > b.user + b.dateAdded) ? 1 : -1);
                        if (reportType === "studentTest"){
                            this.openProcessName = "StudentTest";
                        }else{
                            this.openProcessName = "MoneyMgmtTest";
                        }
                        this.setState({modalOpen: true, waitState: false});
                    }else{
                        if (statusCode ===  250){
                            this.setState({waitState: false});
                            alert ("There is no student test data for the selected class.")
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                    status: statusCode, message: output.body.message};
                            this.props.processError(errorObj);
                        }
                    }
                });
            };
        });
  }

loadDiscussionData(){
    this.gameData = DiscussionGameData;
    this.savingsData = DiscussionSavingsData;
    this.creditCardData = DiscussionCreditCardData;
    this.setState({waitState: true, loadGameData: true, loadSavingsData: true, 
        loadCreditCardData: true, loadCarChoiceData: false, loadHomeChoiceData: false,
        loadJobChoiceData: false, loadTimeWizardData: false});
    this.setGameIdArr();
    this.loadJobChoices();
    this.loadHomeChoices();
    this.loadCarChoices();
    this.loadTimeWizardInfo();
    this.setState({waitState: false, modalOpen: true});
}

loadExtraCredit(){
    const funcName = "loadMultipleExtraCredit";
    let playerArr = (this.parentInfo.relatedPlayers).join(',');
    const urlParm = "?userArr=" + playerArr;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    // fetch of game activity tracker was successful;
                    this.extraCreditArr = output.body;
                    this.waitState = false;
                    this.setState({extraCreditLoaded: true});
                    
                }else{
                    if (statusCode === 250){
                        // fetch successful but no record found;
                        alert("No Extra Credit Data Found");
                        this.waitState = false;
                        this.setState({extraCreditLoaded: true, modalOpen: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                }
            });
            }
    });
  }


}

export default PlayerReports;